import React, {useEffect, useState} from 'react'
import {useSnapEngage} from '../../custom-api/hooks/use-snap-engage'
import {useCustomPreferenceWithLocale} from '../../hooks/use-custom-preference'
import {useLocation} from 'react-router-dom'
import {Global, css} from '@emotion/react'

const HIDE_CSS = css`
    #designstudio-button {
        display: none !important;
    }
`

const SnapEngage = () => {
    const location = useLocation()
    const snapEngageConfig = useCustomPreferenceWithLocale('snapEngageConfiguration')
    const snapEngageWidgetID = snapEngageConfig?.snapEngageWidgetID || ''
    const proactiveChat =
        snapEngageConfig?.proactiveChat === 'true' || snapEngageConfig?.proactiveChat === true

    const snapEnageURLExclusion = snapEngageConfig?.snapEnageURLExclusion || []

    const [hide, setHide] = useState(false)

    useEffect(() => {
        let interval = null

        function registerCallbacks() {
            if (window.SnapEngage && window.SnapEngage.setCallback) {
                ;['Open', 'Close'].forEach((event) => {
                    window.SnapEngage.setCallback(event, () => {
                        setHide(event === 'Open')
                    })
                })
                clearInterval(interval)
            }
        }

        registerCallbacks()
        interval = setInterval(registerCallbacks, 500)

        return () => clearInterval(interval)
    }, [])

    useSnapEngage({snapEngageWidgetID, proactiveChat})

    useEffect(() => {
        let shouldDisableChat = false

        for (let exclusion of snapEnageURLExclusion) {
            try {
                const regex = new RegExp(exclusion)
                if (regex.test(location.pathname)) {
                    shouldDisableChat = true
                    break
                }
            } catch (e) {
                if (location.pathname === exclusion) {
                    shouldDisableChat = true
                    break
                }
            }
        }

        if (window.SnapEngage) {
            window.SnapEngage.allowProactiveChat(!shouldDisableChat)
            shouldDisableChat ? window.SnapEngage.hideButton() : window.SnapEngage.showButton()
        }
    }, [location.pathname, snapEnageURLExclusion])

    return <>{hide && <Global styles={HIDE_CSS} />}</>
}

export default SnapEngage
